/*
 *  ~ Copyright (c) by INFODATA-GROUP. All rights reserved.
 *  ~ No part of this publication may be reproduced, distributed,
 *  ~ or transmitted in any form or by any means, including photocopying, recording,
 *  ~ or other electronic or mechanical methods, without the prior written permission of the publisher,
 *  ~ except in the case of brief quotations embodied in critical
 *  ~ reviews and certain other noncommercial uses permitted by copyright law.
 *  ~ Author : BS
 *  ~ Date : 02/03/2022 11:49
 */

import { LayoutContainerEnum } from '../../enum/layout-container.enum';
import { ExportOptionsEnum } from '../../enum/export-options.enum';

export class Layout {
  public endPoint = '';
  public profil = '';
  public container = LayoutContainerEnum.masterDetail;
  public urlGdx = '';
  public pagination = 50;
  public directSearch = false;
  public exportOptions = [ExportOptionsEnum.pdf, ExportOptionsEnum.csv];

  constructor(endPoint: string) {
    this.endPoint = endPoint;
  }

  public serialize(): any {
    if (!this.endPoint) {
      return null;
    }
    return {
      endPoint: this.endPoint,
      profil: this.profil,
      container: this.container,
      urlGdx: this.urlGdx,
      pagination: this.pagination,
      directSearch: this.directSearch,
      exportOptions: this.exportOptions,
    };
  }
}
